// import { addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration"; // Importing nothing to trigger the side effects, which in this case adds custom reducers.
// import "./Store/Reducers";
import { css } from "styled-components";
// Load all custom widgets so they are included in the bundle.
// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// Enable hot module reloading for custom widgets.
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context('./Components/Widgets', true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));
// load all widgets. Without this they won't be included in the bundle
// ensure HMR works for custom widgets
// if (module.hot) {
//    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

// load all pages. Without this they won't be included in the bundle
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
// if (module.hot) {
//    module.hot.accept(widgets.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// load all widget extensions. They could be loaded individually instead
// const widgetExtensions = require.context("./WidgetExtensions", true);
// widgetExtensions.keys().forEach(key => widgetExtensions(key));

setPreStyleGuideTheme({
    colors: {
        secondary: {
            main: "#080",
        },
    },
    typography: {
        h2: {
            weight: 26,
            transform: "lowercase",
        },
    },
});

setPostStyleGuideTheme({
    colors: {
        primary: {
            main: "#b00",
        },
    },
    typography: {
        body: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        h1: {
            weight: 42,
            italic: true,
            size: "84px",
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
            lineHeight: 1.2,
            transform: "uppercase",
        },
        h2: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        h3: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        h4: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        h5: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        h6: {
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        headerPrimary: {
            forwardAs: "p",
            size: "24px",
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
        headerSecondary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
            transform: "uppercase",
            weight: 800,
        },
        headerTertiary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
    },
    link: { defaultProps: { icon: { iconProps: { color: "secondary", size: 48 } } } },
    button: {
        primary: {
            color: "primary",
            hoverMode: "lighten",
            sizeVariant: "medium",
            css: css`
                &:hover {
                    background-color: rgb(102, 102, 102);
                    border: rgb(102, 102, 102);
                }
            `,
        },
    },
    formField: {
        defaultProps: {
            border: "rounded",
            backgroundColor: "common.accent",
            cssOverrides: {
                formInputWrapper: css`
                    > textarea {
                        resize: none;
                    }
                    > input {
                        word-break: normal;
                    }
                    > span[class^="IconWrapper"] {
                        background: none;
                    }
                    > button {
                        > span[class^="IconWrapper"] {
                            background: none;
                        }
                    }
                `,
            },
        },
    },
    datePicker: {
        defaultProps: {
            cssOverrides: {
                datePicker: css`
                    > div[class^="react-datetime-picker"] {
                        > div > button > span[class^="IconWrapper"] {
                            background: none;
                        }
                        > div > div > input[class^="react-datetime-picker__inputGroup__input"] {
                            padding: 2px;
                        }
                    }
                `,
            },
        },
    },
    focus: {
        color: "#000",
        style: "solid",
        width: "0px",
    },
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 720, 960, 1280],
    },
    radio: {
        defaultProps: {
            css: css`
                input {
                    & + label {
                        &::before {
                            background: #fff;
                        }
                    }
                }
            `,
        },
    },
    dynamicDropdown: {
        defaultProps: {
            iconProps: {
                css: css`
                    position: absolute;
                    box-sizing: border-box;
                    top: 2px;
                    right: 2px;
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 100%;
                    pointer-events: none;
                `,
            }
        }
    },
    select: {
        defaultProps: {
            iconProps: {
                css: css`
                    position: absolute;
                    box-sizing: border-box;
                    top: 2px;
                    right: 2px;
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 100%;
                    pointer-events: none;
                `,
            }
        }
    },
});
